import { useIntl } from "react-intl";

import { MobileNavCard } from "../../mobile-nav/mobile-nav-card";
import { type Product, ProductItem, Treatment } from "../../product-subnav";
import { useAnalytics } from "../hooks/use-analytics";

import { BaseGrid } from "./base-grid";

type ProductsGridProps = {
    products: Product[];
    title: string;
    isMobile: boolean;
    container: "ProductsRecommendationsContainer" | "NewProductsContainer";
};

export const ProductsGrid = ({
    products,
    title,
    isMobile,
    container
}: ProductsGridProps) => {
    const intl = useIntl();

    const { fireCardClicked } = useAnalytics();

    const handleCardClick = (product: Product) => {
        fireCardClicked({
            container,
            product,
            isMobile
        });
    };

    const productItems = products.map((product: Product) => {
        return (
            // This is just a wrapper that doesn't affect user interactivity. Okay to ignore these a11y rules.
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
            <div key={product.id} onClick={() => handleCardClick(product)}>
                {isMobile ? (
                    // @ts-ignore
                    <MobileNavCard
                        {...product}
                        description={intl.formatMessage(product.description)}
                        isNew={product.treatment === Treatment.New}
                        productKey={"home"}
                    />
                ) : (
                    <ProductItem {...product} />
                )}
            </div>
        );
    });

    return (
        <BaseGrid products={productItems} title={title} isMobile={isMobile} />
    );
};
